module.exports = __webpack_public_path__ + "static/media/artist-rush-album-moving.0ff5b161.jpg";